import { z } from 'zod';
export const BucketVencimientoSchema = z.enum([
    'Vencido',
    'Esta semana',
    'Próxima semana',
    '2-4 semanas',
    '30-60 días',
    '60+ días',
]);
export const VencimientoDetalleSchema = z.object({
    entryNo: z.number().int(),
    vendorCode: z.string(),
    vendorName: z.string().nullable(),
    documentNo: z.string().nullable(),
    externalDocumentNo: z.string().nullable(),
    documentType: z.string().nullable(),
    postingDate: z.string().nullable(),
    dueDate: z.string().nullable(),
    paymentTermsCode: z.string().nullable(),
    paymentMethodCode: z.string().nullable(),
    vendorPostingGroup: z.string().nullable(),
    currencyCode: z.string().nullable(),
    remainingAmount: z.number().nullable(),
    remainingAmtLCY: z.number().nullable(),
    daysToDue: z.number().int().nullable(),
    bucketVencimiento: BucketVencimientoSchema,
    linkBC: z.string().nullable(),
    pactado: z.boolean(),
});
export const ListaVencimientosDetalleSchema = z.array(VencimientoDetalleSchema);
//# sourceMappingURL=vencimiento.schema.js.map